import { useEffect, useMemo, useState } from "react";
import { getDateRangeForButton, getFormattedDate } from "util/DateSearchUtils";
import { callApi } from "util/HttpService";
import * as ExcelUtil from 'util/ExcelUtil';
import titleLogo from "asset/photomag_web/img/icon/filled/dashboard_b.svg"
import EqmtSelectBox from "components/web/cmmn/EqmtSelectBox";
import styled from "styled-components";
import EqmtByTypeChart from "./EqmtByTypeChart";
import EqmtDayMonthChart from "./EqmtDayMonthChart";
import moment from "moment";
import EqmtAccuHourlyChart from "./EqmtAccuHourlyChart";
import EqmtHourlyChart from "pages/web/sal-hist/EqmtHourlyChart";
import CustomDatePicker from "components/mobile/UI/DatePicker";
import CmmnRadioBtn from "components/mobile/cmmn/CmmnRadioBtn";
import ButtonUtil from "components/mobile/UI/ButtonUtil";
import { useWindowSize } from "context/WindowSizeContext";
import CmmnGraphBox from "components/mobile/cmmn/CmmnGraphBox";
import CmmnMenuTitleWrap from "components/mobile/cmmn/CmmnMenuTitleWrap";
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { useBrch } from "components/web/auth/BrchProvider";
import SaleByEqmtChart from "pages/web/dsh-brd/component/SaleByEqmtChart";
import CBH3C_img from "asset/photomag_web/img/CBH3C.png";
import CBH4C_img from "asset/photomag_web/img/CBH4C.png";
import CBH3CM_img from "asset/photomag_web/img/CBH3CM.png";
import CBH4CM_img from "asset/photomag_web/img/CBH4CM.png";
import CSH6C_img from "asset/photomag_web/img/CSH6C.png";
// import HSH4C_img from "asset/photomag_web/img/HSH4C.png";
import HSW5C_img from "asset/photomag_web/img/HSW5C.png";
import SSH4C_img from "asset/photomag_web/img/SSH4C.png";
import SSW4C_img from "asset/photomag_web/img/SSW4C.png";
import CBH4C_2_img from "asset/photomag_web/img/CBH4C_2.png";
import CSH6C_2_img from "asset/photomag_web/img/CSH6C_2.png";
import SSH4C_2_img from "asset/photomag_web/img/SSH4C_2.png";
import SSW4C_2_img from "asset/photomag_web/img/SSW4C_2.png";
import S04H12C_img from "asset/photomag_web/img/S04H12C.png";
import S05H12C_img from "asset/photomag_web/img/S05H12C.png";
import S06W12C_img from "asset/photomag_web/img/S06W12C.png";
import S07H24C_img from "asset/photomag_web/img/S07H24C.png";
import model1_img from "asset/photomag_web/img/model1.png";
import model2_img from "asset/photomag_web/img/model2.png";
import model3_img from "asset/photomag_web/img/model3.png";
import model4_img from "asset/photomag_web/img/model4.png";
import model5_img from "asset/photomag_web/img/model5.png";
import model6_img from "asset/photomag_web/img/model6.png";
import model7_img from "asset/photomag_web/img/model7.png";
import model8_img from "asset/photomag_web/img/model8.png";
import model9_img from "asset/photomag_web/img/model9.png";
import model10_img from "asset/photomag_web/img/model10.png";
import model11_img from "asset/photomag_web/img/model11.png";
import model12_img from "asset/photomag_web/img/model12.png";

const DashBoardWrap = styled.div`
	display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px 0 0 0;
	.dashboard-box {
		background-color: #fff;
		border-radius: 16px;
		width: 100%;
		margin-bottom: 20px;
		box-shadow: 0 0 10px rgba(0,0,0,.1);
	}
	@media (max-width: 1200px) {
		.search-option-wrap li:last-child {
			flex-direction: column;
			align-items: flex-start;
		}
		.option-wrap{
			flex-direction: column;
			align-items: flex-start;
			margin: 0 0 20px 0;
		}
		.radio-btn-wrap{
			margin: 10px 0 0 0;
		}
		.search-option-wrap li:first-child{
			margin-bottom: 10px;
		}
		.search-option-wrap li:last-child button{
			width: 100%;
		}
		.box-wrap li h2{
        	font-size: 24px;
    	}
	}
	.space-between {
		justify-content: space-between;
	}
	.alignset {
		display: flex;
		align-items: center;
	}
	.betweenSet {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.col-2 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		& > div {
			width: 49.2%;
		}
	}
	.round-filled-small-btn:hover {
		color: var(--bs-btn-hover-color) !important;
		background-color: var(--bs-btn-hover-bg) !important;
		border-color: var(--bs-btn-hover-border-color) !important;
	}
`;
const SearchWrap = styled.ul`
	padding: 20px;
	li {
		&:first-child {
			margin-bottom: 20px;
		}
		&:last-child button {
			width: 130px;
		}
		&:not(.radio-btn-wrap) {
			display: flex;
    		align-items: center;
		}
		h3 {
			font-size: 16px;
			color: ${({ theme }) => theme.colors.dark2};
			font-weight: 500;
			min-width: 80px;
		}
	}
	.form-select {
		width: 380px;
	}
`;
// web
export default function SalHist() {
	const { brchId, crdInfo } = useBrch(); // 헤더에서 가맹점 변경 시 brchId변경됨
	const isMobile = useWindowSize();
	const { t } = useTranslation();

	const defaultSearchData = {
		brchId: brchId,
		eqmtId: "",
		startDate: "",
		endDate: "",
		division: "HST",
	};

	const dayButtons = [
		{ label: t("saleHistPage.today"), value: "saleHistPage.today" },
		{ label: t("saleHistPage.yesterday"), value: "saleHistPage.yesterday" },
		{ label: t("saleHistPage.thisWeek"), value: "saleHistPage.thisWeek" },
		{ label: t("saleHistPage.lastWeek"), value: "saleHistPage.lastWeek" },
		{ label: t("saleHistPage.lastWeekend"), value: "saleHistPage.lastWeekend" },
		{ label: t("saleHistPage.thisMonth"), value: "saleHistPage.thisMonth" },
		{ label: t("saleHistPage.lastMonth"), value: "saleHistPage.lastMonth" }
	];
	const hourTab = [t("saleHistPage.time"), t("saleHistPage.timeAcc")];
	// const hourAccuTab = [t("saleHistPage.timeAcc")];
	const paymentTypeTab = [t("saleHistPage.sale"), t("saleHistPage.numberOfOccur")];
	// const frameTab = [t("saleHistPage.frame"), t("saleHistPage.colorBackground"), t("saleHistPage.bgTop15"), t("saleHistPage.filter")];
	const frameTab = [t("saleHistPage.frame"), t("saleHistPage.bgTop15"), t("saleHistPage.entertain"), t("saleHistPage.filter")];
	const dayMonthTab = [t("saleHistPage.daily"), t("saleHistPage.monthly")];
	// const monthTab = [t("saleHistPage.monthly")];
	const salesByEqmtTab = [t("saleHistPage.salesByEqmt")];

	const [searchData, setSearchData] = useState(defaultSearchData);
	const [radioValue, setRadioValue] = useState("saleHistPage.today");

	const [sumInfo, setSumInfo] = useState({});
	const [totSalesInfo, setTotSalesInfo] = useState({});
	const [totCntInfo, setTotCntInfo] = useState({});
	const [totFremCntInfo, setTotFremCntInfo] = useState({});
	const [totColorBgCntInfo, setTotColorBgCntInfo] = useState({});
	const [totYiColorBgCntInfo, setTotYiColorBgCntInfo] = useState({});
	const [totEventBgCntInfo, setTotEventBgCntInfo] = useState({});
	const [totYiEventBgCntInfo, setYiTotEventBgCntInfo] = useState({});
	const [totFilterCntInfo, setTotFilterCntInfo] = useState({});
	const [totEntertainCntInfo, setTotEntertainCntInfo] = useState({});
	const [hourlySalesList, setHourlySalesList] = useState([]);
	const [hourlyAccuSalesList, setHourlyAccuSalesList] = useState([]);
	const [dailySalesList, setDailySalesList] = useState([]);
	const [monthSalesList, setMonthSalesList] = useState([]);
	const [salesByEqmtList, setSalesByEqmtList] = useState([]);

	const [timeArray, setTimeArray] = useState([]);
	const [dayDateArray, setDayDateArray] = useState([]);
	const [monthDateArray, setMonthDateArray] = useState([]);

	/* 시간별 매출 */
	const hourlyArray = () => {
		const hours = [];
		for (let i = 0; i < 24; i++) {
			const hour = i < 10 ? `0${i}` : `${i}`;
			hours.push(`${hour}`);
		}
		return hours;
	};

	/* 일월별 매출 */
	const dayArray = () => {
		const today = moment();
		const result = {
			thisMonth: [],
			lastMonth: []
		};
		// 이번 달 날짜 배열 생성
		const startOfMonth = today.clone().startOf('month');
		for (let i = 0; i < today.date(); i++) {
			const currentDate = startOfMonth.clone().date(i + 1);
			const formattedDate = currentDate.format('YYYY-MM-DD');
			result.thisMonth.push(formattedDate);
		}
		// 저번 달 날짜 배열 생성
		const lastMonth = today.clone().subtract(1, 'month');
		for (let i = 0; i < lastMonth.daysInMonth(); i++) {
			const currentDate = lastMonth.clone().date(i + 1);
			const formattedDate = currentDate.format('YYYY-MM-DD');
			result.lastMonth.push(formattedDate);
		}
		return result;
	};
	const monthArray = () => {
		const today = moment();
		const result = {
			thisYearMonth: [],
			lastYearMonth: [],
		};
		for (let i = 11; i >= 0; i--) {
			const currentMonth = today.clone().subtract(i, 'months').format('YYYYMM');
			result.thisYearMonth.push(currentMonth);
		}
		for (let i = 12; i >= 1; i--) {
			const lastMonth = today.clone().subtract(i, 'months').format('YYYYMM');
			result.lastYearMonth.push(lastMonth);
		}
		return result;
	};

	useEffect(() => {
		handleButtonClick(t("saleHistPage.today"));
		const handleLanguageChange = () => {
			setRadioValue(prevValue => prevValue); // radioValue를 키 값으로 유지
		};
		i18next.on('languageChanged', handleLanguageChange);
		return () => {
			i18next.off('languageChanged', handleLanguageChange);
		};
	}, []);

	/* 검색버튼을 클릭할 때 조회 */
	const salesListSearch = async () => {
		setHourlySalesList([]);
		setHourlyAccuSalesList([]);
		setDailySalesList([]);
		setMonthSalesList([]);

		try {
			const now = moment();
			const startOfToday = now.clone().startOf('day').format("YYYY-MM-DD");
			const startOfYesterday = now.clone().subtract(1, 'day').startOf('day').format("YYYY-MM-DD");
			const startOfMonth = now.clone().startOf('month').startOf('day').format("YYYY-MM-DD");
			const endOfMonth = now.clone().endOf('month').startOf('day').format("YYYY-MM-DD");
			const startOfLastMonth = now.clone().subtract(1, 'month').startOf('month').startOf('day').format("YYYY-MM-DD");
			const endOfLastMonth = now.clone().subtract(1, 'month').endOf('month').startOf('day').format("YYYY-MM-DD");

			const dates = dayArray();
			const months = monthArray();
			const isThisMonth = searchData.startDate === startOfMonth && searchData.endDate === endOfMonth;
			const isLastMonth = searchData.startDate === startOfLastMonth && searchData.endDate === endOfLastMonth;

			const totalCountInfoPromise = callApi("POST", searchData, "/web/api/sal-hist/eph/total");
			const sumListPromise = callApi("POST", searchData, "/web/api/sal-hist/eph/sum");
			const salesByEqmtPromise = callApi("POST", searchData, "/web/api/sal-hist/eph/sales-by-eqmt");

			let hourlySalesPromise = Promise.resolve([]);
			const isToday = moment(searchData.startDate).isSame(now, 'day') && moment(searchData.endDate).isSame(now, 'day');
			const isYesterday = moment(searchData.startDate).isSame(now.clone().subtract(1, 'day'), 'day') && moment(searchData.endDate).isSame(now.clone().subtract(1, 'day'), 'day');

			if (isToday || isYesterday) {
				const hourList = hourlyArray();
				setTimeArray(hourList);
				const hourParams = { ...searchData, hourList: hourList, division: "HST" };
				hourlySalesPromise = callApi("POST", hourParams, "/web/api/sal-hist/eph/hour-sales");
			} else {
				setHourlySalesList([]);
				setHourlyAccuSalesList([]);
			}

			let dailySalesPromise = Promise.resolve([]);
			let monthlySalesPromise = Promise.resolve([]);
			if (!isThisMonth && !isLastMonth) {
				setDailySalesList([]);
			} else if (isThisMonth || isLastMonth) {
				const dayList = isThisMonth ? dates.thisMonth : dates.lastMonth;
				setDayDateArray(dayList);
				const params = { ...searchData, dayList: dayList };
				dailySalesPromise = callApi("POST", params, "/web/api/sal-hist/eph/daily-sales");

				const monthList = isThisMonth ? months.thisYearMonth : months.lastYearMonth;
				setMonthDateArray(monthList);
				const dateType = isThisMonth ? "thisMonth" : "lastMonth";
				const monthParams = { ...searchData, monthList: monthList, dateType: dateType };
				monthlySalesPromise = callApi("POST", monthParams, "/web/api/sal-hist/eph/month-sales");
			}

			const [totalCountInfo, hourlySales, sumList, dailySales, monthSales, salesByEqmtList] = await Promise.all([
				totalCountInfoPromise,
				hourlySalesPromise,
				sumListPromise,
				dailySalesPromise,
				monthlySalesPromise,
				salesByEqmtPromise,
			]);
			// 시간별 매출 - 배열안의 값이 0인 배열은 빈 배열로 처리
			// console.log(hourlySales);
			// hourlySales.forEach((data, index) => {
			// 	if (data.every(value => value === 0)) {
			// 		hourlySales[index] = [];
			// 	}
			// });
			console.log(hourlySales);
			setSumInfo(sumList);
			setTotSalesInfo(totalCountInfo.stlmTotalSales);
			setTotCntInfo(totalCountInfo.stlmTotalCnt);
			setTotFremCntInfo(totalCountInfo.fremTotalCnt);
			setTotColorBgCntInfo(totalCountInfo.colorBgTotalCnt);
			setTotYiColorBgCntInfo(totalCountInfo.yiColorBgTotalCnt);
			setTotEventBgCntInfo(totalCountInfo.eventBgTotalCnt);
			setYiTotEventBgCntInfo(totalCountInfo.yiEventBgTotalCnt);
			setTotFilterCntInfo(totalCountInfo.filterTotalCnt);
			setTotEntertainCntInfo(totalCountInfo.entertainTotalCnt);
			//hourlySales를 JSON 객체로 받아온 경우에만 시간/시간누적 구분하여 해당하는 객체를 배열형태로 리스트에 삽입
			if (hourlySales && Object.keys(hourlySales).length > 0) { 
				const hsArray = [
					hourlySales.todayHourlyTotal,     // 오늘 시간별 합계
					hourlySales.yesterdayHourlyTotal, // 어제 시간별 합계
				];
				
				const hsaArray = [
					hourlySales.todayStacked,			// 오늘 결제구분별/시간별 누적 합계
					hourlySales.yesterdayStacked		// 어제 결제구분별/시간별 누적 합계
				]
				setHourlySalesList(hsArray);
				setHourlyAccuSalesList(hsaArray);
			} else {
				setHourlySalesList(hourlySales);
				setHourlyAccuSalesList(hourlySales);
			}
			setSalesByEqmtList(salesByEqmtList);
			// console.log(salesByEqmtList);

			if (dailySales.length) {
				setDailySalesList(dailySales);
			}
			if (dailySales.length) {
				setMonthSalesList(monthSales);
			}

		} catch (error) {
			console.error('Error:', error);
		}
	};

	const handelFormDataChange = (e) => {
		const { name, value } = e.target;
		setSearchData((prevData) => ({
			...prevData,
			[name]: value,
		}));
	};

	const handelDatePickerChange = (date, name) => {
		setSearchData((prevData) => ({
			...prevData,
			[name]: getFormattedDate(date, "yyyy-MM-dd"),
		}));
		setRadioValue('');
	};

	const handleButtonClickWrapper = (value) => {
		handleButtonClick(t(value));
		setRadioValue(value);
	};

	/* 기간 - 버튼을 클릭할 때 조회 */
	const handleButtonClick = async (btnNm) => {
		let { startDate, endDate } = getDateRangeForButton(btnNm, t);
		setSearchData((prevData) => ({
			...prevData,
			startDate: startDate,
			endDate: endDate,
		}));

		let params = { ...searchData, startDate: startDate, endDate: endDate };
		let totalCountInfoPromise, hourlySalesPromise, sumListPromise, dailySalesPromise, monthlySalesPromise, salesByEqmtPromise;

		const now = moment();
		const startOfToday = now.clone().startOf('day').format("YYYY-MM-DD");
		const startOfYesterday = now.clone().subtract(1, 'day').startOf('day').format("YYYY-MM-DD");
		const startOfMonth = now.clone().startOf('month').startOf('day').format("YYYY-MM-DD");
		const endOfMonth = now.clone().endOf('month').startOf('day').format("YYYY-MM-DD");
		const startOfLastMonth = now.clone().subtract(1, 'month').startOf('month').startOf('day').format("YYYY-MM-DD");
		const endOfLastMonth = now.clone().subtract(1, 'month').endOf('month').startOf('day').format("YYYY-MM-DD");
		const dates = dayArray();
		const months = monthArray();

		switch (btnNm) {
			case t("saleHistPage.today"):
				console.log(`${btnNm} searchData`, params);
				const isToday = params.startDate === startOfToday;

				if (!isToday) {
					setHourlySalesList([]);
					setHourlyAccuSalesList([]);
					hourlySalesPromise = Promise.resolve([]);
				} else {
					const hourList = hourlyArray();
					setTimeArray(hourList);
					const hourParams = { ...params, hourList: hourList, division: "HST" };
					// console.log(hourParams);
					hourlySalesPromise = callApi("POST", hourParams, "/web/api/sal-hist/eph/hour-sales");
				}
				break;

			case t("saleHistPage.yesterday"):
				console.log(`${btnNm} searchData`, params);

				const isYesterday = params.startDate === startOfYesterday;

				if (!isYesterday) {
					setHourlySalesList([]);
					setHourlyAccuSalesList([]);
					hourlySalesPromise = Promise.resolve([]);
				} else {
					const hourList = hourlyArray();
					setTimeArray(hourList);
					const hourParams = { ...params, hourList: hourList, division: "HST" };
					hourlySalesPromise = callApi("POST", hourParams, "/web/api/sal-hist/eph/hour-sales");
				}
				break;
			case t("saleHistPage.thisWeek"):
			case t("saleHistPage.lastWeek"):
			case t("saleHistPage.lastWeekend"):
				console.log(`${btnNm} searchData`, params);
				break;

			case t("saleHistPage.thisMonth"):
			case t("saleHistPage.lastMonth"):
				console.log(`${btnNm} searchData`, params);

				const isThisMonth = params.startDate === startOfMonth && params.endDate === endOfMonth;
				const isLastMonth = params.startDate === startOfLastMonth && params.endDate === endOfLastMonth;

				if (!isThisMonth && !isLastMonth) {
					setDailySalesList([]);
					setMonthSalesList([]);
					dailySalesPromise = Promise.resolve([]);
					monthlySalesPromise = Promise.resolve([]);
				} else {
					const dayList = isThisMonth ? dates.thisMonth : dates.lastMonth;
					setDayDateArray(dayList);
					const newParams = { ...params, dayList: dayList };
					dailySalesPromise = callApi("POST", newParams, "/web/api/sal-hist/eph/daily-sales");

					const monthList = isThisMonth ? months.thisYearMonth : months.lastYearMonth;
					setMonthDateArray(monthList);
					const dateType = isThisMonth ? "thisMonth" : "lastMonth";
					const monthParams = { ...searchData, monthList: monthList, dateType: dateType };
					monthlySalesPromise = callApi("POST", monthParams, "/web/api/sal-hist/eph/month-sales");
				}
				break;

			default: break;
		}

		totalCountInfoPromise = callApi("POST", params, "/web/api/sal-hist/eph/total");
		sumListPromise = callApi("POST", params, "/web/api/sal-hist/eph/sum");
		salesByEqmtPromise = callApi("POST", params, "/web/api/sal-hist/eph/sales-by-eqmt");

		try {
			const [totalCountInfo, hourlySales, sumList, dailySales, monthSales, salesByEqmtList] = await Promise.all([
				totalCountInfoPromise,
				hourlySalesPromise || Promise.resolve([]),
				sumListPromise,
				dailySalesPromise || Promise.resolve([]),
				monthlySalesPromise || Promise.resolve([]),
				salesByEqmtPromise,
			]);

			// 시간별 매출 - 배열안의 값이 0인 배열은 빈 배열로 처리
			// hourlySales.forEach((data, index) => {
			// 	if (data.every(value => value === 0)) {
			// 		hourlySales[index] = [];
			// 	}
			// });
			console.log(hourlySales);
			setTotSalesInfo(totalCountInfo.stlmTotalSales);
			setTotCntInfo(totalCountInfo.stlmTotalCnt);
			setTotFremCntInfo(totalCountInfo.fremTotalCnt);
			// console.log(totalCountInfo);
			setTotColorBgCntInfo(totalCountInfo.colorBgTotalCnt);
			setTotYiColorBgCntInfo(totalCountInfo.yiColorBgTotalCnt);
			setTotEventBgCntInfo(totalCountInfo.eventBgTotalCnt);
			setYiTotEventBgCntInfo(totalCountInfo.yiEventBgTotalCnt);
			setTotFilterCntInfo(totalCountInfo.filterTotalCnt);
			setTotEntertainCntInfo(totalCountInfo.entertainTotalCnt);
			//hourlySales를 JSON 객체로 받아온 경우에만 시간/시간누적 구분하여 해당하는 객체를 배열형태로 리스트에 삽입
			if (hourlySales && Object.keys(hourlySales).length > 0) { 
				const hsArray = [
					hourlySales.todayHourlyTotal,     // 오늘 시간별 합계
					hourlySales.yesterdayHourlyTotal, // 어제 시간별 합계
				];
				
				const hsaArray = [
					hourlySales.todayStacked,			// 오늘 결제구분별/시간별 누적 합계
					hourlySales.yesterdayStacked		// 어제 결제구분별/시간별 누적 합계
				]
				setHourlySalesList(hsArray);
				setHourlyAccuSalesList(hsaArray);
			} else {
				setHourlySalesList(hourlySales);
				setHourlyAccuSalesList(hourlySales);
			}
			setSumInfo(sumList);
			setSalesByEqmtList(salesByEqmtList);
			// console.log(salesByEqmtList);

			if (dailySales.length) {
				const updatedDailySales = dailySales.map(data => data === null ? 0 : data);
				setDailySalesList(updatedDailySales);
			} else {
				setDailySalesList([]);
			}
			if (monthSales.length) {
				const updatedMonthSales = monthSales.map(data => data === null ? 0 : data);
				setMonthSalesList(updatedMonthSales);
			} else {
				setMonthSalesList([]);
			}
		} catch (error) {
			console.error('Error:', error);
		}
	};

	const excelDownloadBtn = async () => {
		const params = { ...searchData, brchNm: crdInfo.brchNm };
		ExcelUtil.downloadExcelFromServer(`/web/api/sal-hist/eph/excel-down`, params, t("saleHistPage.saleStat"));
	}

	const handleCmmnBtnClick = (btnNm) => {
		switch (btnNm) {
			case "cmmnSearchBtn":
				salesListSearch();
				break;
			case "cmmnExcelDownloadBtn":
				excelDownloadBtn();
				break;
			default: break;
		}
	}

	let colorBgData;
	let eventBgData;

	
	const salesData = [
		{ label: "CARD", amount: totSalesInfo.cardAmt, ratio: totSalesInfo.cardRto, backgroundColor: "#e50200" },
		{ label: "CASH", amount: totSalesInfo.cashAmt, ratio: totSalesInfo.cashRto, backgroundColor: "#fcc355" },
		{ label: "CUPON", amount: totSalesInfo.cupnAmt, ratio: totSalesInfo.cupnRto, backgroundColor: "#37d1cc" },
		{ label: "QR", amount: totSalesInfo.qrAmt, ratio: totSalesInfo.qrRto, backgroundColor: "#0400ffff" },
		{ label: "POINT", amount: totSalesInfo.pontAmt, ratio: totSalesInfo.pontRto, backgroundColor: "#1a89e3" },
		{ label: "FREE", amount: totSalesInfo.freeAmt, ratio: totSalesInfo.freeRto, backgroundColor: "#a231d5" },
		{ label: "COIN", amount: totSalesInfo.evciAmt, ratio: totSalesInfo.evciRto, backgroundColor: "#ff6347" },
		{ label: "CASH+COIN", amount: totSalesInfo.csecAmt, ratio: totSalesInfo.csecRto, backgroundColor: "#32cd32" },
	];
	const salesCntData = [
		{ label: "CARD", amount: totCntInfo.cardCnt, ratio: totCntInfo.cardRto, backgroundColor: "#e50200" },
		{ label: "CASH", amount: totCntInfo.cashCnt, ratio: totCntInfo.cashRto, backgroundColor: "#fcc355" },
		{ label: "CUPON", amount: totCntInfo.cupnCnt, ratio: totCntInfo.cupnRto, backgroundColor: "#37d1cc" },
		{ label: "QR", amount: totCntInfo.qrCnt, ratio: totCntInfo.qrRto, backgroundColor: "#0400ffff" },
		{ label: "POINT", amount: totCntInfo.pontCnt, ratio: totCntInfo.pontRto, backgroundColor: "#1a89e3" },
		{ label: "FREE", amount: totCntInfo.freeCnt, ratio: totCntInfo.freeRto, backgroundColor: "#a231d5" },
		{ label: "COIN", amount: totCntInfo.evciCnt, ratio: totCntInfo.evciRto, backgroundColor: "#ff6347" },
		{ label: "CASH+COIN", amount: totCntInfo.csecCnt, ratio: totCntInfo.csecRto, backgroundColor: "#32cd32" },
	];
	const frmeData = [
		{ label: "CBH3C", amount: totFremCntInfo.cbh3cCnt, ratio: totFremCntInfo.cbh3cRto, backgroundColor: "#EEB764", image: [CBH3C_img] },
		{ label: "CBH4C", amount: totFremCntInfo.cbh4cCnt, ratio: totFremCntInfo.cbh4cRto, backgroundColor: "#FFAFB0", image: [CBH4C_img, CBH4C_2_img] },
		{ label: "CBH3CM", amount: totFremCntInfo.cbh3cMCnt, ratio: totFremCntInfo.cbh3cMRto, backgroundColor: "#f1a22b", image: [CBH3CM_img] },
		{ label: "CBH4CM", amount: totFremCntInfo.cbh4cMCnt, ratio: totFremCntInfo.cbh4cMRto, backgroundColor: "#f05a5d", image: [CBH4CM_img] },
		{ label: "CSH6C", amount: totFremCntInfo.csh6cCnt, ratio: totFremCntInfo.csh6cRto, backgroundColor: "#FFAFD8", image: [CSH6C_img, CSH6C_2_img] },
		// { label: "HSH4C", amount: totFremCntInfo.hsh4cCnt, ratio: totFremCntInfo.hsh4cRto, backgroundColor: "#B5C7ED", image: HSH4C_img },
		{ label: "HSW5C", amount: totFremCntInfo.hsw5cCnt, ratio: totFremCntInfo.hsw5cRto, backgroundColor: "#AFFFBA", image: [HSW5C_img] },
		{ label: "SSH4C", amount: totFremCntInfo.ssh4cCnt, ratio: totFremCntInfo.ssh4cRto, backgroundColor: "#A7DAD8", image: [SSH4C_img, SSH4C_2_img] },
		{ label: "SSW4C", amount: totFremCntInfo.ssw4cCnt, ratio: totFremCntInfo.ssw4cRto, backgroundColor: "#FFF4B2", image: [SSW4C_img, SSW4C_2_img] },

        { label: "S04H12C", amount: totFremCntInfo.s04h12cCnt, ratio: totFremCntInfo.s04h12cRto, backgroundColor: "#2697e2ff", image: [S04H12C_img] },
        { label: "S05H12C", amount: totFremCntInfo.s05h12cCnt, ratio: totFremCntInfo.s05h12cRto, backgroundColor: "#c220e2ff", image: [S05H12C_img] },
        { label: "S06W12C", amount: totFremCntInfo.s06w12cCnt, ratio: totFremCntInfo.s06w12cRto, backgroundColor: "#1bd61bff", image: [S06W12C_img] },
        { label: "S07H24C", amount: totFremCntInfo.s07h24cCnt, ratio: totFremCntInfo.s07h24cRto, backgroundColor: "#eb1212ff", image: [S07H24C_img] },
	];
	if (totColorBgCntInfo != null && totColorBgCntInfo !== undefined) {
		colorBgData = [
			{ label: "BLACK", amount: totColorBgCntInfo.cblackCnt, ratio: totColorBgCntInfo.cblackRto, backgroundColor: "#5F5F5F" },
			{ label: "WHITE", amount: totColorBgCntInfo.cwhiteCnt, ratio: totColorBgCntInfo.cwhiteRto, backgroundColor: "#f7f8f6" },
			{ label: "GRAY", amount: totColorBgCntInfo.cgrayCnt, ratio: totColorBgCntInfo.cgrayRto, backgroundColor: "#B0B0B0" },
			{ label: "BLUE", amount: totColorBgCntInfo.cblueCnt, ratio: totColorBgCntInfo.cblueRto, backgroundColor: "#1A66CC" },
			{ label: "GREEN", amount: totColorBgCntInfo.cgreenCnt, ratio: totColorBgCntInfo.cgreenRto, backgroundColor: "#009900" },
			{ label: "PURPLE", amount: totColorBgCntInfo.cpurpleCnt, ratio: totColorBgCntInfo.cpurpleRto, backgroundColor: "#9D4CCC" },
			{ label: "PURPLEMIX", amount: totColorBgCntInfo.cpurplemCnt, ratio: totColorBgCntInfo.cpurplemRto, backgroundColor: "#D9A1BF" },
			{ label: "PURPLEFOIL", amount: totColorBgCntInfo.cpurplefCnt, ratio: totColorBgCntInfo.cpurplefRto, backgroundColor: "#D8BFFF" },
			{ label: "GREENMIX", amount: totColorBgCntInfo.cgreenmCnt, ratio: totColorBgCntInfo.cgreenmRto, backgroundColor: "#A5D6A7" },
			{ label: "YELLOW", amount: totColorBgCntInfo.cyellowCnt, ratio: totColorBgCntInfo.cyellowRto, backgroundColor: "#FFE680" },
            
            { label: "CSTKR01", amount: totColorBgCntInfo.cstkr01Cnt, ratio: totColorBgCntInfo.cstkr01Rto, backgroundColor: "#98b10eff" },
            { label: "CSTKR02", amount: totColorBgCntInfo.cstkr02Cnt, ratio: totColorBgCntInfo.cstkr02Rto, backgroundColor: "#41ca17ff" },
            { label: "CSTKR03", amount: totColorBgCntInfo.cstkr03Cnt, ratio: totColorBgCntInfo.cstkr03Rto, backgroundColor: "#8d2ee6ff" },
            { label: "CSTKR04", amount: totColorBgCntInfo.cstkr04Cnt, ratio: totColorBgCntInfo.cstkr04Rto, backgroundColor: "#e08215ff" },
            { label: "CSTKR05", amount: totColorBgCntInfo.cstkr05Cnt, ratio: totColorBgCntInfo.cstkr05Rto, backgroundColor: "#8880ffff" },
            { label: "CSTKR06", amount: totColorBgCntInfo.cstkr06Cnt, ratio: totColorBgCntInfo.cstkr06Rto, backgroundColor: "#80ffd5ff" },
            { label: "CSTKR07", amount: totColorBgCntInfo.cstkr07Cnt, ratio: totColorBgCntInfo.cstkr07Rto, backgroundColor: "#ff80a0ff" },
            { label: "CSTKR08", amount: totColorBgCntInfo.cstkr08Cnt, ratio: totColorBgCntInfo.cstkr08Rto, backgroundColor: "#a280ffff" },
            { label: "CSTKR09", amount: totColorBgCntInfo.cstkr09Cnt, ratio: totColorBgCntInfo.cstkr09Rto, backgroundColor: "#8082ffff" },
            { label: "CSTKR10", amount: totColorBgCntInfo.cstkr10Cnt, ratio: totColorBgCntInfo.cstkr10Rto, backgroundColor: "#80ffb5ff" },
		];
	} else {
		colorBgData = [
			{ label: "C01", amount: totYiColorBgCntInfo.c01Cnt, ratio: totYiColorBgCntInfo.c01Rto, backgroundColor: "#82C4D9" },
			{ label: "C02", amount: totYiColorBgCntInfo.c02Cnt, ratio: totYiColorBgCntInfo.c02Rto, backgroundColor: "#A386A3" },
			{ label: "C03", amount: totYiColorBgCntInfo.c03Cnt, ratio: totYiColorBgCntInfo.c03Rto, backgroundColor: "#FFFF8C" },
			{ label: "C04", amount: totYiColorBgCntInfo.c04Cnt, ratio: totYiColorBgCntInfo.c04Rto, backgroundColor: "#FFAA96" },
			{ label: "C05", amount: totYiColorBgCntInfo.c05Cnt, ratio: totYiColorBgCntInfo.c05Rto, backgroundColor: "#E18494" },
			{ label: "C06", amount: totYiColorBgCntInfo.c06Cnt, ratio: totYiColorBgCntInfo.c06Rto, backgroundColor: "#9DA3B6" },
			{ label: "C07", amount: totYiColorBgCntInfo.c07Cnt, ratio: totYiColorBgCntInfo.c07Rto, backgroundColor: "#F6AEBB" },
			{ label: "C08", amount: totYiColorBgCntInfo.c08Cnt, ratio: totYiColorBgCntInfo.c08Rto, backgroundColor: "#F7B090" },
			{ label: "C09", amount: totYiColorBgCntInfo.c09Cnt, ratio: totYiColorBgCntInfo.c09Rto, backgroundColor: "#E4D591" },
		];
	}
	if (totEventBgCntInfo != null && totEventBgCntInfo !== undefined) {
		eventBgData = [
			{ label: "MAGAZINE", amount: totEventBgCntInfo.ecmagzeCnt, ratio: totEventBgCntInfo.ecmagzeRto, backgroundColor: "#FFAFB0" },
			{ label: "RAIN", amount: totEventBgCntInfo.esrainCnt, ratio: totEventBgCntInfo.esrainRto, backgroundColor: "#FFAFD8" },
			{ label: "ELEVATOR", amount: totEventBgCntInfo.ehelvtrCnt, ratio: totEventBgCntInfo.ehelvtrRto, backgroundColor: "#EEB764" },
			{ label: "SEASON", amount: totEventBgCntInfo.ecsesnCnt, ratio: totEventBgCntInfo.ecsesnRto, backgroundColor: "#F2CFA5" },
			{ label: "TEEN1", amount: totEventBgCntInfo.ecteen1Cnt, ratio: totEventBgCntInfo.ecteen1Rto, backgroundColor: "#99FFFF" },
			{ label: "TEEN2", amount: totEventBgCntInfo.ecteen2Cnt, ratio: totEventBgCntInfo.ecteen2Rto, backgroundColor: "#ACC4FF" },
			{ label: "LOCAL", amount: totEventBgCntInfo.eclocalCnt, ratio: totEventBgCntInfo.eclocalRto, backgroundColor: "#FFC4C4" },
			{ label: "XMAS1", amount: totEventBgCntInfo.ecxmas1Cnt, ratio: totEventBgCntInfo.ecxmas1Rto, backgroundColor: "#CBAACB" },
			{ label: "XMAS2", amount: totEventBgCntInfo.ecxmas2Cnt, ratio: totEventBgCntInfo.ecxmas2Rto, backgroundColor: "#CAA6FE" },
			{ label: "SEASON2", amount: totEventBgCntInfo.ecsesn2Cnt, ratio: totEventBgCntInfo.ecsesn2Rto, backgroundColor: "#55CBCD" },
			{ label: "AURA1", amount: totEventBgCntInfo.efaura1Cnt, ratio: totEventBgCntInfo.efaura1Rto, backgroundColor: "#AFFFBA" },
			{ label: "AURA2", amount: totEventBgCntInfo.efaura2Cnt, ratio: totEventBgCntInfo.efaura2Rto, backgroundColor: "#E2FFAF" },
			{ label: "AURA3", amount: totEventBgCntInfo.efaura3Cnt, ratio: totEventBgCntInfo.efaura3Rto, backgroundColor: "#FFFE9E" },
			{ label: "FRUIT1", amount: totEventBgCntInfo.effrut1Cnt, ratio: totEventBgCntInfo.effrut1Rto, backgroundColor: "#CCE5FF" },
			{ label: "FRUIT2", amount: totEventBgCntInfo.effrut2Cnt, ratio: totEventBgCntInfo.effrut2Rto, backgroundColor: "#FFE4AF" },
			{ label: "CHAR1", amount: totEventBgCntInfo.efchar1Cnt, ratio: totEventBgCntInfo.efchar1Rto, backgroundColor: "#83A7A3" },
			{ label: "CHAR2", amount: totEventBgCntInfo.efchar2Cnt, ratio: totEventBgCntInfo.efchar2Rto, backgroundColor: "#ACB890" },
			{ label: "BEAR1", amount: totEventBgCntInfo.esbear1Cnt, ratio: totEventBgCntInfo.esbear1Rto, backgroundColor: "#DFD4E4" },
			{ label: "BEAR2", amount: totEventBgCntInfo.esbear2Cnt, ratio: totEventBgCntInfo.esbear2Rto, backgroundColor: "#FFD8B1" },
			{ label: "WBBLACK", amount: totEventBgCntInfo.ecwbblackCnt, ratio: totEventBgCntInfo.ecwbblackRto, backgroundColor: "#D8B1FF" },
			{ label: "BLUEFUR", amount: totEventBgCntInfo.ecbefurCnt, ratio: totEventBgCntInfo.ecbefurRto, backgroundColor: "#B1FFD8" },
			{ label: "SILVER", amount: totEventBgCntInfo.wsilverCnt, ratio: totEventBgCntInfo.wsilverRto, backgroundColor: "#B1D8FF" },
			{ label: "SILVER2", amount: totEventBgCntInfo.esilver2Cnt, ratio: totEventBgCntInfo.esilver2Rto, backgroundColor: "#FFB1E1" },
			{ label: "VINTAGE", amount: totEventBgCntInfo.wcvntgCnt, ratio: totEventBgCntInfo.wcvntgRto, backgroundColor: "#C1FFA3" },
			{ label: "CHOCO", amount: totEventBgCntInfo.wchocoCnt, ratio: totEventBgCntInfo.wchocoRto, backgroundColor: "#DDB88D" },
			{ label: "FLOWER", amount: totEventBgCntInfo.eflowerCnt, ratio: totEventBgCntInfo.eflowerRto, backgroundColor: "#FFB7C5" },
			{ label: "WCBEARP", amount: totEventBgCntInfo.wcbearpCnt, ratio: totEventBgCntInfo.wcbearpRto, backgroundColor: "#FA87E5" },
			{ label: "WCBEARG", amount: totEventBgCntInfo.wcbeargCnt, ratio: totEventBgCntInfo.wcbeargRto, backgroundColor: "#98FB98" },
            { label: "WCBEARB", amount: totEventBgCntInfo.wcbearbCnt, ratio: totEventBgCntInfo.wcbearbRto, backgroundColor: "#98d7fb" },

            { label: "WCSTWWD", amount: totEventBgCntInfo.wcstwwdCnt, ratio: totEventBgCntInfo.wcstwwdRto, backgroundColor: "#C4B2D5" },
            { label: "ECSTWWD1", amount: totEventBgCntInfo.ecstwwd1Cnt, ratio: totEventBgCntInfo.ecstwwd1Rto, backgroundColor: "#DB9EC0" },
            { label: "ECSTWWD2", amount: totEventBgCntInfo.ecstwwd2Cnt, ratio: totEventBgCntInfo.ecstwwd2Rto, backgroundColor: "#95C499" },
            { label: "WCSTWWD3", amount: totEventBgCntInfo.wcstwwd3Cnt, ratio: totEventBgCntInfo.wcstwwd3Rto, backgroundColor: "#BDCCFF" },

			{ label: "ECEVENT1", amount: totEventBgCntInfo.ecevent1Cnt, ratio: totEventBgCntInfo.ecevent1Rto, backgroundColor: "#020614ff" },
			{ label: "ECEVENT2", amount: totEventBgCntInfo.ecevent2Cnt, ratio: totEventBgCntInfo.ecevent2Rto, backgroundColor: "#1f3372ff" },
			{ label: "ECEVENT3", amount: totEventBgCntInfo.ecevent3Cnt, ratio: totEventBgCntInfo.ecevent3Rto, backgroundColor: "#6521d3ff" },
			{ label: "ECEVENT4", amount: totEventBgCntInfo.ecevent4Cnt, ratio: totEventBgCntInfo.ecevent4Rto, backgroundColor: "#168077ff" },
			{ label: "ECEVENT5", amount: totEventBgCntInfo.ecevent5Cnt, ratio: totEventBgCntInfo.ecevent5Rto, backgroundColor: "#25799bff" },
			{ label: "WCEVENT1", amount: totEventBgCntInfo.wcevent1Cnt, ratio: totEventBgCntInfo.wcevent1Rto, backgroundColor: "#d1daaeff" },
			{ label: "WCEVENT2", amount: totEventBgCntInfo.wcevent2Cnt, ratio: totEventBgCntInfo.wcevent2Rto, backgroundColor: "#89d159ff" },
			{ label: "WCEVENT3", amount: totEventBgCntInfo.wcevent3Cnt, ratio: totEventBgCntInfo.wcevent3Rto, backgroundColor: "#ee9888ff" },
			{ label: "WCEVENT4", amount: totEventBgCntInfo.wcevent4Cnt, ratio: totEventBgCntInfo.wcevent4Rto, backgroundColor: "#e4bb4cff" },
			{ label: "WCEVENT5", amount: totEventBgCntInfo.wcevent5Cnt, ratio: totEventBgCntInfo.wcevent5Rto, backgroundColor: "#e66c72ff" },

			{ label: "WBLACK", amount: totEventBgCntInfo.wblackCnt, ratio: totEventBgCntInfo.wblackRto, backgroundColor: "#050505ff" },
			{ label: "WWHITE", amount: totEventBgCntInfo.wwhiteCnt, ratio: totEventBgCntInfo.wwhiteRto, backgroundColor: "#0e89eeff" },
            
            { label: "WCSTKR01", amount: totEventBgCntInfo.wcstkr01Cnt, ratio: totEventBgCntInfo.wcstkr01Rto, backgroundColor: "#e64709ff" },
            { label: "WCSTKR02", amount: totEventBgCntInfo.wcstkr02Cnt, ratio: totEventBgCntInfo.wcstkr02Rto, backgroundColor: "#ee550eff" },   
            { label: "WCSTKR03", amount: totEventBgCntInfo.wcstkr03Cnt, ratio: totEventBgCntInfo.wcstkr03Rto, backgroundColor: "#ee850eff" },
            { label: "WCSTKR04", amount: totEventBgCntInfo.wcstkr04Cnt, ratio: totEventBgCntInfo.wcstkr04Rto, backgroundColor: "#abee0eff" },
            { label: "WCSTKR05", amount: totEventBgCntInfo.wcstkr05Cnt, ratio: totEventBgCntInfo.wcstkr05Rto, backgroundColor: "#0eee21ff" },
            { label: "WCSTKR06", amount: totEventBgCntInfo.wcstkr06Cnt, ratio: totEventBgCntInfo.wcstkr06Rto, backgroundColor: "#0eee64ff" },
            { label: "WCSTKR07", amount: totEventBgCntInfo.wcstkr07Cnt, ratio: totEventBgCntInfo.wcstkr07Rto, backgroundColor: "#0eee64ff" },
            { label: "WCSTKR08", amount: totEventBgCntInfo.wcstkr08Cnt, ratio: totEventBgCntInfo.wcstkr08Rto, backgroundColor: "#0eee85ff" },
            { label: "WCSTKR09", amount: totEventBgCntInfo.wcstkr09Cnt, ratio: totEventBgCntInfo.wcstkr09Rto, backgroundColor: "#0eeeabff" },
            { label: "WCSTKR10", amount: totEventBgCntInfo.wcstkr10Cnt, ratio: totEventBgCntInfo.wcstkr10Rto, backgroundColor: "#0eeedbff" },
            { label: "WCSTKR11", amount: totEventBgCntInfo.wcstkr11Cnt, ratio: totEventBgCntInfo.wcstkr11Rto, backgroundColor: "#0eaeeeff" },
            { label: "WCSTKR12", amount: totEventBgCntInfo.wcstkr12Cnt, ratio: totEventBgCntInfo.wcstkr12Rto, backgroundColor: "#0e42eeff" },
            { label: "WCSTKR13", amount: totEventBgCntInfo.wcstkr13Cnt, ratio: totEventBgCntInfo.wcstkr13Rto, backgroundColor: "#300eeeff" },
            { label: "WCSTKR14", amount: totEventBgCntInfo.wcstkr14Cnt, ratio: totEventBgCntInfo.wcstkr14Rto, backgroundColor: "#1d0eeeff" },
            { label: "WCSTKR15", amount: totEventBgCntInfo.wcstkr15Cnt, ratio: totEventBgCntInfo.wcstkr15Rto, backgroundColor: "#820eeeff" },
            { label: "WCSTKR16", amount: totEventBgCntInfo.wcstkr16Cnt, ratio: totEventBgCntInfo.wcstkr16Rto, backgroundColor: "#db0eeeff" },
            { label: "WCSTKR17", amount: totEventBgCntInfo.wcstkr17Cnt, ratio: totEventBgCntInfo.wcstkr17Rto, backgroundColor: "#ee0ea3ff" },
            { label: "WCSTKR18", amount: totEventBgCntInfo.wcstkr18Cnt, ratio: totEventBgCntInfo.wcstkr18Rto, backgroundColor: "#ee0eabff" },
            { label: "WCSTKR19", amount: totEventBgCntInfo.wcstkr19Cnt, ratio: totEventBgCntInfo.wcstkr19Rto, backgroundColor: "#ee0e6bff" },
            { label: "WCSTKR20", amount: totEventBgCntInfo.wcstkr20Cnt, ratio: totEventBgCntInfo.wcstkr20Rto, backgroundColor: "#ee0e2cff" },

			{ label: "E01", amount: totEventBgCntInfo.e01Cnt, ratio: totEventBgCntInfo.e01Rto, backgroundColor: "#82C4D9" },
			{ label: "E02", amount: totEventBgCntInfo.e02Cnt, ratio: totEventBgCntInfo.e02Rto, backgroundColor: "#A386A3" },
			{ label: "E03", amount: totEventBgCntInfo.e03Cnt, ratio: totEventBgCntInfo.e03Rto, backgroundColor: "#FFFF8C" },
			{ label: "E04", amount: totEventBgCntInfo.e04Cnt, ratio: totEventBgCntInfo.e04Rto, backgroundColor: "#FFAA96" },
			{ label: "E05", amount: totEventBgCntInfo.e05Cnt, ratio: totEventBgCntInfo.e05Rto, backgroundColor: "#E18494" },
			{ label: "E06", amount: totEventBgCntInfo.e06Cnt, ratio: totEventBgCntInfo.e06Rto, backgroundColor: "#9DA3B6" },
			{ label: "E07", amount: totEventBgCntInfo.e07Cnt, ratio: totEventBgCntInfo.e07Rto, backgroundColor: "#F6AEBB" },
			{ label: "E08", amount: totEventBgCntInfo.e08Cnt, ratio: totEventBgCntInfo.e08Rto, backgroundColor: "#F7B090" },
			{ label: "E09", amount: totEventBgCntInfo.e09Cnt, ratio: totEventBgCntInfo.e09Rto, backgroundColor: "#E4D591" },
			{ label: "E10", amount: totEventBgCntInfo.e10Cnt, ratio: totEventBgCntInfo.e10Rto, backgroundColor: "#6e601eff" },
			{ label: "E11", amount: totEventBgCntInfo.e11Cnt, ratio: totEventBgCntInfo.e11Rto, backgroundColor: "#0c586eff" },
			{ label: "E12", amount: totEventBgCntInfo.e12Cnt, ratio: totEventBgCntInfo.e12Rto, backgroundColor: "#d41cd4ff" },
			{ label: "E13", amount: totEventBgCntInfo.e13Cnt, ratio: totEventBgCntInfo.e13Rto, backgroundColor: "#00ad96ff" },
			{ label: "E14", amount: totEventBgCntInfo.e14Cnt, ratio: totEventBgCntInfo.e14Rto, backgroundColor: "#ee6a4cff" },
			{ label: "E15", amount: totEventBgCntInfo.e15Cnt, ratio: totEventBgCntInfo.e15Rto, backgroundColor: "#270d11ff" },
			{ label: "E16", amount: totEventBgCntInfo.e16Cnt, ratio: totEventBgCntInfo.e16Rto, backgroundColor: "#b3b7c5ff" },
			{ label: "E17", amount: totEventBgCntInfo.e17Cnt, ratio: totEventBgCntInfo.e17Rto, backgroundColor: "#770f91ff" },
			{ label: "E18", amount: totEventBgCntInfo.e18Cnt, ratio: totEventBgCntInfo.e18Rto, backgroundColor: "#742e0eff" },
			{ label: "E19", amount: totEventBgCntInfo.e19Cnt, ratio: totEventBgCntInfo.e19Rto, backgroundColor: "#17740eff" },
			{ label: "E20", amount: totEventBgCntInfo.e20Cnt, ratio: totEventBgCntInfo.e20Rto, backgroundColor: "#1ef7d2ff" },
			
			{ label: "C01", amount: totEventBgCntInfo.c01Cnt, ratio: totEventBgCntInfo.c01Rto, backgroundColor: "#417f92ff" },
			{ label: "C02", amount: totEventBgCntInfo.c02Cnt, ratio: totEventBgCntInfo.c02Rto, backgroundColor: "#5e3d5eff" },
			{ label: "C03", amount: totEventBgCntInfo.c03Cnt, ratio: totEventBgCntInfo.c03Rto, backgroundColor: "#77772dff" },
			{ label: "C04", amount: totEventBgCntInfo.c04Cnt, ratio: totEventBgCntInfo.c04Rto, backgroundColor: "#e65b3cff" },
			{ label: "C05", amount: totEventBgCntInfo.c05Cnt, ratio: totEventBgCntInfo.c05Rto, backgroundColor: "#2c38a5ff" },
			{ label: "C06", amount: totEventBgCntInfo.c06Cnt, ratio: totEventBgCntInfo.c06Rto, backgroundColor: "#344b96ff" },
			{ label: "C07", amount: totEventBgCntInfo.c07Cnt, ratio: totEventBgCntInfo.c07Rto, backgroundColor: "#a5223aff" },
			{ label: "C08", amount: totEventBgCntInfo.c08Cnt, ratio: totEventBgCntInfo.c08Rto, backgroundColor: "#c4bebbff" },
			{ label: "C09", amount: totEventBgCntInfo.c09Cnt, ratio: totEventBgCntInfo.c09Rto, backgroundColor: "#fff0abff" },
			{ label: "C10", amount: totEventBgCntInfo.c10Cnt, ratio: totEventBgCntInfo.c10Rto, backgroundColor: "#ffde3bff" },
			{ label: "C11", amount: totEventBgCntInfo.c11Cnt, ratio: totEventBgCntInfo.c11Rto, backgroundColor: "#45d7ffff" },
			{ label: "C12", amount: totEventBgCntInfo.c12Cnt, ratio: totEventBgCntInfo.c12Rto, backgroundColor: "#ff58ffff" },
			{ label: "C13", amount: totEventBgCntInfo.c13Cnt, ratio: totEventBgCntInfo.c13Rto, backgroundColor: "#00ffddff" },
			{ label: "C14", amount: totEventBgCntInfo.c14Cnt, ratio: totEventBgCntInfo.c14Rto, backgroundColor: "#ff2f00ff" },
			{ label: "C15", amount: totEventBgCntInfo.c15Cnt, ratio: totEventBgCntInfo.c15Rto, backgroundColor: "#742935ff" },
			{ label: "C16", amount: totEventBgCntInfo.c16Cnt, ratio: totEventBgCntInfo.c16Rto, backgroundColor: "#c3d0ffff" },
			{ label: "C17", amount: totEventBgCntInfo.c17Cnt, ratio: totEventBgCntInfo.c17Rto, backgroundColor: "#cc00ffff" },
			{ label: "C18", amount: totEventBgCntInfo.c18Cnt, ratio: totEventBgCntInfo.c18Rto, backgroundColor: "#ff5100ff" },
			{ label: "C19", amount: totEventBgCntInfo.c19Cnt, ratio: totEventBgCntInfo.c19Rto, backgroundColor: "#84ffeaff" },
			{ label: "C20", amount: totEventBgCntInfo.c20Cnt, ratio: totEventBgCntInfo.c20Rto, backgroundColor: "#00ff0dff" },
			
		];
	} else {
		eventBgData = [
			{ label: "E01", amount: totYiEventBgCntInfo.e01Cnt, ratio: totYiEventBgCntInfo.e01Rto, backgroundColor: "#82C4D9" },
			{ label: "E02", amount: totYiEventBgCntInfo.e02Cnt, ratio: totYiEventBgCntInfo.e02Rto, backgroundColor: "#A386A3" },
			{ label: "E03", amount: totYiEventBgCntInfo.e03Cnt, ratio: totYiEventBgCntInfo.e03Rto, backgroundColor: "#FFFF8C" },
			{ label: "E04", amount: totYiEventBgCntInfo.e04Cnt, ratio: totYiEventBgCntInfo.e04Rto, backgroundColor: "#FFAA96" },
			{ label: "E05", amount: totYiEventBgCntInfo.e05Cnt, ratio: totYiEventBgCntInfo.e05Rto, backgroundColor: "#E18494" },
			{ label: "E06", amount: totYiEventBgCntInfo.e06Cnt, ratio: totYiEventBgCntInfo.e06Rto, backgroundColor: "#9DA3B6" },
			{ label: "E07", amount: totYiEventBgCntInfo.e07Cnt, ratio: totYiEventBgCntInfo.e07Rto, backgroundColor: "#F6AEBB" },
			{ label: "E08", amount: totYiEventBgCntInfo.e08Cnt, ratio: totYiEventBgCntInfo.e08Rto, backgroundColor: "#F7B090" },
			{ label: "E09", amount: totYiEventBgCntInfo.e09Cnt, ratio: totYiEventBgCntInfo.e09Rto, backgroundColor: "#E4D591" },
		];
	}
	const filterData = [
		{ label: "ORIGINAL", amount: totFilterCntInfo.orglCnt, ratio: totFilterCntInfo.orglRto, backgroundColor: "#8FD9A8" },
		{ label: "WHITENING", amount: totFilterCntInfo.whtnCnt, ratio: totFilterCntInfo.whtnRto, backgroundColor: "#FFAEB1" },
		{ label: "COOL", amount: totFilterCntInfo.coolCnt, ratio: totFilterCntInfo.coolRto, backgroundColor: "#55CBCD" },
		{ label: "WARM", amount: totFilterCntInfo.warmCnt, ratio: totFilterCntInfo.warmRto, backgroundColor: "#FEE1E8" },
		{ label: "GRAY", amount: totFilterCntInfo.grayCnt, ratio: totFilterCntInfo.grayRto, backgroundColor: "#C6CBDA" },
		{ label: "REVERSE", amount: totFilterCntInfo.rvrsCnt, ratio: totFilterCntInfo.rvrsRto, backgroundColor: "#DABFFF" },
		// { label: "GRAY2", amount: totFilterCntInfo.gray2Cnt, ratio: totFilterCntInfo.gray2Rto, backgroundColor: "#8A8D9B" },
		{ label: "S4", amount: totFilterCntInfo.s4Cnt, ratio: totFilterCntInfo.s4Rto, backgroundColor: "#FFD3B6" },
		{ label: "S5", amount: totFilterCntInfo.s5Cnt, ratio: totFilterCntInfo.s5Rto, backgroundColor: "#B5EAD7" },
		{ label: "S6", amount: totFilterCntInfo.s6Cnt, ratio: totFilterCntInfo.s6Rto, backgroundColor: "#A3C9F9" },
		{ label: "RETRO", amount: totFilterCntInfo.retroCnt, ratio: totFilterCntInfo.retroRto, backgroundColor: "#8A8D9B" },
	];

	const entertainData = useMemo(() => ([
		{ label: "MODEL1", amount: totEntertainCntInfo.entModl1Cnt, ratio: totEntertainCntInfo.entModl1Rto, backgroundColor: "#8FD9A8" ,image: [model1_img]},
		{ label: "MODEL2", amount: totEntertainCntInfo.entModl2Cnt, ratio: totEntertainCntInfo.entModl2Rto, backgroundColor: "#FFAEB1" ,image: [model2_img]},
		{ label: "MODEL3", amount: totEntertainCntInfo.entModl3Cnt, ratio: totEntertainCntInfo.entModl3Rto, backgroundColor: "#55CBCD" ,image: [model3_img]},
		{ label: "MODEL4", amount: totEntertainCntInfo.entModl4Cnt, ratio: totEntertainCntInfo.entModl4Rto, backgroundColor: "#FEE1E8" ,image: [model4_img]},
		{ label: "MODEL5", amount: totEntertainCntInfo.entModl5Cnt, ratio: totEntertainCntInfo.entModl5Rto, backgroundColor: "#42c23dff" ,image: [model5_img]},
		{ label: "MODEL6", amount: totEntertainCntInfo.entModl6Cnt, ratio: totEntertainCntInfo.entModl6Rto, backgroundColor: "#DABFFF" ,image: [model6_img]},
		{ label: "MODEL7", amount: totEntertainCntInfo.entModl7Cnt, ratio: totEntertainCntInfo.entModl7Rto, backgroundColor: "#0126ccff" ,image: [model7_img]},
		{ label: "MODEL8", amount: totEntertainCntInfo.entModl8Cnt, ratio: totEntertainCntInfo.entModl8Rto, backgroundColor: "#FFD3B6" ,image: [model8_img]},
		{ label: "MODEL9", amount: totEntertainCntInfo.entModl9Cnt, ratio: totEntertainCntInfo.entModl9Rto, backgroundColor: "#B5EAD7" ,image: [model9_img]},
		{ label: "MODEL10", amount: totEntertainCntInfo.entModl10Cnt, ratio: totEntertainCntInfo.entModl10Rto, backgroundColor: "#C4B2D5" ,image: [model10_img]},
		{ label: "MODEL11", amount: totEntertainCntInfo.entModl11Cnt, ratio: totEntertainCntInfo.entModl11Rto, backgroundColor: "#FFFF8C" ,image: [model11_img]},
		{ label: "MODEL12", amount: totEntertainCntInfo.entModl12Cnt, ratio: totEntertainCntInfo.entModl12Rto, backgroundColor: "#A3C9F9" ,image: [model12_img]},
	]),[totEntertainCntInfo]);

	// 컬러 + 이벤트 상위 15개 추출
	const mergedTop15BgData = useMemo(() => {
		const merged = [...colorBgData, ...eventBgData];

		// 값이 있는 데이터만 추출
		const filtered = merged.filter(item => item.amount > 0);

		if (filtered.length === 0) {
			return [
				{ label: "No Data", amount: 0, ratio: 0, backgroundColor: "#D3D3D3" }
			];
		}

		// 상위 15개 데이터 추출
		const top15 = filtered
			.sort((a, b) => b.amount - a.amount)
			.slice(0, 15);
			
		const total = top15.reduce((sum, item) => sum + item.amount, 0);

		return top15.map(item => ({
			...item,
			ratio: total > 0 ? +(item.amount / total * 100).toFixed(2) : 0
		}));
	}, [colorBgData, eventBgData]);

	// console.log(mergedTop15BgData);

	// Entertain 값이 있는데이터만 추출
	const entertainExistsData = useMemo(() => {
		
		const filtered = entertainData.filter(item => item.amount > 0);
		
		if(filtered.length === 0) {
			return [
				{ label: "No Data", amount:0, ratio:0, backgroundColor: "#D3D3D3" }
			];
		}

		return filtered;
	},[entertainData]);
	

	const paymentTypeTabs = [
		{ tabTitle: t("saleHistPage.sale"), graphComponent: <EqmtByTypeChart salesData={salesData} unit={crdInfo && crdInfo.natnCd === "KR" ? "₩" : crdInfo && crdInfo.natnCd === "JP" ? "¥" : "$"} label={t("saleHistPage.sale")} /> },
		{ tabTitle: t("saleHistPage.numberOfOccur"), graphComponent: <EqmtByTypeChart salesData={salesCntData} text={t("dashboardPage.occur")} label={t("saleHistPage.payment")} /> }
	];
	const fremTypeTabs = [
		{ tabTitle: t("saleHistPage.frame"), graphComponent: <EqmtByTypeChart salesData={frmeData} text={t("dashboardPage.occur")} label={t("common.selectLable")} /> },
		// { tabTitle: t("saleHistPage.colorBackground"), graphComponent: <EqmtByTypeChart salesData={colorBgData} text={t("dashboardPage.occur")} label={t("common.selectLable")} /> },
		{ tabTitle: t("saleHistPage.bgTop15"), graphComponent: <EqmtByTypeChart salesData={mergedTop15BgData} text={t("dashboardPage.occur")} label={t("common.selectLable")} /> },
		{ tabTitle: t("saleHistPage.entertain"), graphComponent: <EqmtByTypeChart salesData={entertainExistsData} text={t("dashboardPage.occur")} label={t("common.selectLable")} /> },
		{ tabTitle: t("saleHistPage.filter"), graphComponent: <EqmtByTypeChart salesData={filterData} text={t("dashboardPage.occur")} label={t("common.selectLable")} /> },
	];
	const hourlyTypeTabs = [
		{ tabTitle: t("saleHistPage.time"), graphComponent: <EqmtHourlyChart salesData={hourlySalesList} dateArray={timeArray} searchData={searchData} crdInfo={crdInfo} /> },
		{ tabTitle: t("saleHistPage.hourlyAccuSale"), graphComponent: <EqmtAccuHourlyChart salesData={hourlyAccuSalesList} dateArray={timeArray} searchData={searchData} crdInfo={crdInfo} /> }
	];
	// const accuHourlyTypeTabs = [{ tabTitle: t("saleHistPage.hourlyAccuSale"), graphComponent: <EqmtAccuHourlyChart salesData={hourlySalesList} dateArray={timeArray} searchData={searchData} crdInfo={crdInfo} /> }];
	const dayMonthTabs = [
		{ tabTitle: t("saleHistPage.daily"), graphComponent: <EqmtDayMonthChart salesData={dailySalesList} dateArray={dayDateArray} title={t("saleHistPage.daily")} label={t("saleHistPage.sale")} crdInfo={crdInfo} /> },
		{ tabTitle: t("saleHistPage.monthly"), graphComponent: <EqmtDayMonthChart salesData={monthSalesList} dateArray={monthDateArray} title={t("saleHistPage.monthly")} label={t("saleHistPage.sale")} crdInfo={crdInfo} /> }
	];
	// const monthTabs = [{ tabTitle: t("saleHistPage.monthly"), graphComponent: <EqmtDayMonthChart salesData={monthSalesList} dateArray={monthDateArray} title={t("saleHistPage.monthly")} label={t("saleHistPage.sale")} crdInfo={crdInfo} /> }];

	const salesByEqmtTabs = [{ tabTitle: t("saleHistPage.salesByEqmt"), graphComponent: <SaleByEqmtChart salesData={salesByEqmtList} text={crdInfo && crdInfo.natnCd === "KR" ? "₩" : crdInfo && crdInfo.natnCd === "JP" ? "¥" : "$"} /> }]

	return (
		<div className="padding-box">
			<div className="title-wrap">
				<div className="title">
					<div className="alignset">
						<img src={titleLogo} alt={t("saleHistPage.saleStat")} />
						<h2>{t("saleHistPage.saleStat")}</h2>
					</div>
					<p>Home {">"} {t("saleHistPage.saleStat")}</p>
				</div>
			</div>
			<DashBoardWrap>
				<div className="dashboard-box">
					<SearchWrap className="search-option-wrap">
						<li>
							<h3>{t("saleHistPage.eqmtNm")}</h3>
							<EqmtSelectBox
								defaultVal={searchData.eqmtId}
								tagName={"eqmtId"}
								defaultOptTxt={t("saleHistPage.entire")}
								brchId={searchData.brchId}
								onSelectChange={handelFormDataChange}
							/>
						</li>
						<li className="space-between">
							<div className="alignset">
								<h3>{t("common.periodLable")}</h3>
								<div className="alignset option-wrap">
									<CustomDatePicker
										defaultStartDate={searchData.startDate}
										defaultEndDate={searchData.endDate}
										onSelectChange={handelDatePickerChange}
										isMobile={isMobile}
									/>
								</div>
								<CmmnRadioBtn
									dataArray={dayButtons.map(button => ({ ...button, label: t(button.value) }))}
									onSelectChange={(e) => { handleButtonClickWrapper(e.target.value); }}
									className="radio-btn-wrap"
									defaultVal={radioValue}
									isMobile={isMobile}
								/>
							</div>
							<ButtonUtil
								value={t("common.searchLable")}
								className="btn btn-danger round-filled-small-btn small-btn"
								name="cmmnSearchBtn"
								onClick={() => { handleCmmnBtnClick("cmmnSearchBtn") }}
							/>
						</li>
					</SearchWrap>
				</div>
				<CmmnMenuTitleWrap
					title={t("leftMenu.salHist")}
					searchData={searchData}
					dataInfo={sumInfo}
					isMobile={isMobile}
					onCmmnBtnClick={handleCmmnBtnClick}
					crdInfo={crdInfo}
				/>
				<div className="col-2">
					<CmmnGraphBox
						title={t("saleHistPage.salesByEqmt")}
						tabs={salesByEqmtTab}
						graphComponents={salesByEqmtTabs.map(tab => tab.graphComponent)}
						subTitle={`${t("saleHistPage.sale")} (${crdInfo && crdInfo.natnCd === "KR" ? "₩" : crdInfo && crdInfo.natnCd === "JP" ? "¥" : "$"} ${Intl.NumberFormat("ko-KR",{}).format(salesByEqmtList.length !== 0 && salesByEqmtList[0].totalAmt)})`}
					/>
					<CmmnGraphBox
						title={t("saleHistPage.paymentType")}
						tabs={paymentTypeTab}
						graphComponents={paymentTypeTabs.map(tab => tab.graphComponent)}
					/>
				</div>
				<div className="col-2">
					<CmmnGraphBox
						title={t("saleHistPage.frameAndBackgroundSelectCnt")}
						tabs={frameTab}
						graphComponents={fremTypeTabs.map(tab => tab.graphComponent)}
					/>
					{/* {hourlySalesList.every(data => data.length === 0) ? <></> */}
					{!hourlySalesList || hourlySalesList.length === 0 || hourlyTypeTabs.length === 0 ? <></>
						: 
						<CmmnGraphBox
							title={t("saleHistPage.salesByHour")}
							tabs={hourTab}
							graphComponents={hourlyTypeTabs.map(tab => tab.graphComponent)}
						/>
					}
					{(dailySalesList.every(data => data === 0) && monthSalesList.every(data => data === 0)) ?
						<></>
						:
						<CmmnGraphBox
							title={`${t("saleHistPage.dailyMonthlySale")}`}
							tabs={dayMonthTab}
							graphComponents={dayMonthTabs.map(tab => tab.graphComponent)}
						/>
					}
				</div>
				{/* {hourlySalesList.every(data => data.length === 0) ?
					<></>
					:
					<div className="col-2">
						<CmmnGraphBox
							title={t("saleHistPage.hourlyAccuSale")}
							tabs={hourAccuTab}
							graphComponents={accuHourlyTypeTabs.map(tab => tab.graphComponent)}
						/>
					</div>
				} */}
				{/* {(dailySalesList.every(data => data === 0) && monthSalesList.every(data => data === 0)) ?
					<></>
					:
					<div className="col-2">
						<CmmnGraphBox
							title={`${t("saleHistPage.daily")} ${t("saleHistPage.sale")}`}
							tabs={dayTab}
							graphComponents={dayTabs.map(tab => tab.graphComponent)}
						/>
						<CmmnGraphBox
							title={`${t("saleHistPage.monthly")} ${t("saleHistPage.sale")}`}
							tabs={monthTab}
							graphComponents={monthTabs.map(tab => tab.graphComponent)}
						/>
					</div>
				} */}
			</DashBoardWrap>
		</div>
	)
}